export { default as accessSvg } from './access.vue';
export { default as access3Svg } from './access3.vue';
export { default as accessLogoSvg } from './accessLogo.vue';
export { default as addCircleSvg } from './addCircle.vue';
export { default as addUserSvg } from './addUser.vue';
export { default as alarmSvg } from './alarm.vue';
export { default as alertSvg } from './alert.vue';
export { default as alertLineSvg } from './alertLine.vue';
export { default as apiSvg } from './api.vue';
export { default as arrowForwardSvg } from './arrowForward.vue';
export { default as arrowrightcircleSvg } from './arrowrightcircle.vue';
export { default as badgeCheckSvg } from './badgeCheck.vue';
export { default as basisSvg } from './basis.vue';
export { default as bellSvg } from './bell.vue';
export { default as binSvg } from './bin.vue';
export { default as binocularsSvg } from './binoculars.vue';
export { default as bookReaderSvg } from './bookReader.vue';
export { default as boxSvg } from './box.vue';
export { default as businessSvg } from './business.vue';
export { default as calculatorSvg } from './calculator.vue';
export { default as calendarSvg } from './calendar.vue';
export { default as cancelSvg } from './cancel.vue';
export { default as caretRightSvg } from './caretRight.vue';
export { default as caretUpDownSvg } from './caretUpDown.vue';
export { default as chartCandlestickSvg } from './chartCandlestick.vue';
export { default as chartOverlaysSvg } from './chartOverlays.vue';
export { default as checkSvg } from './check.vue';
export { default as checkcircleSvg } from './checkcircle.vue';
export { default as chevronDoubleDownSvg } from './chevronDoubleDown.vue';
export { default as chevronDoubleRightSvg } from './chevronDoubleRight.vue';
export { default as chevrondownSvg } from './chevrondown.vue';
export { default as chevronleftSvg } from './chevronleft.vue';
export { default as chevronrightSvg } from './chevronright.vue';
export { default as chevronupSvg } from './chevronup.vue';
export { default as circleSvg } from './circle.vue';
export { default as clearSvg } from './clear.vue';
export { default as clockbackSvg } from './clockback.vue';
export { default as closeSvg } from './close.vue';
export { default as connectionSvg } from './connection.vue';
export { default as connectLogoSvg } from './connectLogo.vue';
export { default as contactSvg } from './contact.vue';
export { default as copySvg } from './copy.vue';
export { default as copyAltSvg } from './copyAlt.vue';
export { default as crispSvg } from './crisp.vue';
export { default as crossSvg } from './cross.vue';
export { default as crossOutlineSvg } from './crossOutline.vue';
export { default as crownSvg } from './crown.vue';
export { default as dashboardSvg } from './dashboard.vue';
export { default as dashboardGridSvg } from './dashboardGrid.vue';
export { default as diamondSvg } from './diamond.vue';
export { default as documentSvg } from './document.vue';
export { default as documentAddSvg } from './documentAdd.vue';
export { default as documentArrowUpSvg } from './documentArrowUp.vue';
export { default as dollarSvg } from './dollar.vue';
export { default as dollarAltSvg } from './dollarAlt.vue';
export { default as doubleCheckSvg } from './doubleCheck.vue';
export { default as downloadSvg } from './download.vue';
export { default as dragHandleSvg } from './dragHandle.vue';
export { default as dropSvg } from './drop.vue';
export { default as earSvg } from './ear.vue';
export { default as earFilledSvg } from './earFilled.vue';
export { default as earnKeysSvg } from './earnKeys.vue';
export { default as editSvg } from './edit.vue';
export { default as engineSvg } from './engine.vue';
export { default as evolutionSvg } from './evolution.vue';
export { default as excelSvg } from './excel.vue';
export { default as experimentSvg } from './experiment.vue';
export { default as externalLinkSvg } from './externalLink.vue';
export { default as eyeSvg } from './eye.vue';
export { default as eyeCancelSvg } from './eyeCancel.vue';
export { default as eyeCloseSvg } from './eyeClose.vue';
export { default as eyeOpenSvg } from './eyeOpen.vue';
export { default as freightSvg } from './freight.vue';
export { default as freightAltLineSvg } from './freightAltLine.vue';
export { default as freightFfaSvg } from './freightFfa.vue';
export { default as gasSvg } from './gas.vue';
export { default as gasTransitSvg } from './gasTransit.vue';
export { default as globeSvg } from './globe.vue';
export { default as globe2Svg } from './globe2.vue';
export { default as gpsSvg } from './gps.vue';
export { default as graph3Svg } from './graph3.vue';
export { default as graphlineSvg } from './graphline.vue';
export { default as graphlineboxSvg } from './graphlinebox.vue';
export { default as helpSvg } from './help.vue';
export { default as helpFilledSvg } from './helpFilled.vue';
export { default as historySvg } from './history.vue';
export { default as homeFilledSvg } from './homeFilled.vue';
export { default as horizontalBarChartSvg } from './horizontalBarChart.vue';
export { default as hubsCargoSvg } from './hubs-cargo.vue';
export { default as hubsRegasSvg } from './hubs-regas.vue';
export { default as iceSvg } from './ice.vue';
export { default as incognitoSvg } from './incognito.vue';
export { default as infoSvg } from './info.vue';
export { default as infoAltSvg } from './infoAlt.vue';
export { default as insightSvg } from './insight.vue';
export { default as keySvg } from './key.vue';
export { default as keyHighResSvg } from './keyHighRes.vue';
export { default as kplerSvg } from './kpler.vue';
export { default as kplerVesselSvg } from './kplerVessel.vue';
export { default as leafSvg } from './leaf.vue';
export { default as leftcircleSvg } from './leftcircle.vue';
export { default as lightningSvg } from './lightning.vue';
export { default as liquidityRangeSvg } from './liquidityRange.vue';
export { default as liveSvg } from './live.vue';
export { default as lngSvg } from './lng.vue';
export { default as lockSvg } from './lock.vue';
export { default as lockAltSvg } from './lockAlt.vue';
export { default as loginSvg } from './login.vue';
export { default as logoSvg } from './logo.vue';
export { default as logOutSvg } from './logOut.vue';
export { default as mailaddSvg } from './mailadd.vue';
export { default as mailOpenSvg } from './mailOpen.vue';
export { default as mailsendSvg } from './mailsend.vue';
export { default as maximizeSvg } from './maximize.vue';
export { default as menuSvg } from './menu.vue';
export { default as messageSvg } from './message.vue';
export { default as miniChartLineSvg } from './miniChartLine.vue';
export { default as minusSvg } from './minus.vue';
export { default as moreSvg } from './more.vue';
export { default as moreverticalSvg } from './morevertical.vue';
export { default as mouseScrollSvg } from './mouseScroll.vue';
export { default as mouseScrollHorizontalSvg } from './mouseScrollHorizontal.vue';
export { default as netbackSvg } from './netback.vue';
export { default as neutralLineSvg } from './neutralLine.vue';
export { default as neutralLineCancelSvg } from './neutralLineCancel.vue';
export { default as newSvg } from './new.vue';
export { default as nexusSvg } from './nexus.vue';
export { default as optiSvg } from './opti.vue';
export { default as organisationSvg } from './organisation.vue';
export { default as pageSvg } from './page.vue';
export { default as pasteSvg } from './paste.vue';
export { default as penSvg } from './pen.vue';
export { default as pinSvg } from './pin.vue';
export { default as plugSvg } from './plug.vue';
export { default as plugConnectedSvg } from './plug-connected.vue';
export { default as plusSvg } from './plus.vue';
export { default as pointsSvg } from './points.vue';
export { default as pollSvg } from './poll.vue';
export { default as pollFilledSvg } from './pollFilled.vue';
export { default as portCombinedSvg } from './portCombined.vue';
export { default as portDischargeSvg } from './portDischarge.vue';
export { default as portLoadSvg } from './portLoad.vue';
export { default as priceChangeSvg } from './priceChange.vue';
export { default as pricediscoverySvg } from './pricediscovery.vue';
export { default as profileSvg } from './profile.vue';
export { default as profilefilledSvg } from './profilefilled.vue';
export { default as qrCodeSvg } from './qrCode.vue';
export { default as questionMarkSvg } from './questionMark.vue';
export { default as redoSvg } from './redo.vue';
export { default as rightcircleSvg } from './rightcircle.vue';
export { default as rocketSvg } from './rocket.vue';
export { default as routesSvg } from './routes.vue';
export { default as searchSvg } from './search.vue';
export { default as selectedCircleSvg } from './selectedCircle.vue';
export { default as settingSvg } from './setting.vue';
export { default as settingsAltSvg } from './settingsAlt.vue';
export { default as shareSvg } from './share.vue';
export { default as signalsSvg } from './signals.vue';
export { default as singleSwordSvg } from './singleSword.vue';
export { default as smileSvg } from './smile.vue';
export { default as sortAscSvg } from './sortAsc.vue';
export { default as sortDescSvg } from './sortDesc.vue';
export { default as spendKeysSvg } from './spendKeys.vue';
export { default as spinnerSvg } from './spinner.vue';
export { default as spreadSvg } from './spread.vue';
export { default as squareSvg } from './square.vue';
export { default as starSvg } from './star.vue';
export { default as starfilledSvg } from './starfilled.vue';
export { default as starpartialSvg } from './starpartial.vue';
export { default as swapSvg } from './swap.vue';
export { default as swordsSvg } from './swords.vue';
export { default as swordsFilledSvg } from './swordsFilled.vue';
export { default as tenderSvg } from './tender.vue';
export { default as testTubeSvg } from './testTube.vue';
export { default as thumbsDownSvg } from './thumbsDown.vue';
export { default as thumbsUpSvg } from './thumbsUp.vue';
export { default as timeSvg } from './time.vue';
export { default as timerSvg } from './timer.vue';
export { default as timerAltSvg } from './timerAlt.vue';
export { default as toolSvg } from './tool.vue';
export { default as treeSvg } from './tree.vue';
export { default as trophySvg } from './trophy.vue';
export { default as undoSvg } from './undo.vue';
export { default as unlockSvg } from './unlock.vue';
export { default as uploadSvg } from './upload.vue';
export { default as usersSvg } from './users.vue';
export { default as verifiedSvg } from './verified.vue';
export { default as verticalBarChartSvg } from './verticalBarChart.vue';
export { default as vesselSvg } from './vessel.vue';
export { default as warningSvg } from './warning.vue';
export { default as webhookSvg } from './webhook.vue';
export { default as youtubeSvg } from './youtube.vue';
export { default as youtubeColoredSvg } from './youtubeColored.vue';
